import { render, staticRenderFns } from "./PromotoresDetractores.vue?vue&type=template&id=69394ec3&scoped=true"
import script from "./PromotoresDetractores.vue?vue&type=script&lang=js"
export * from "./PromotoresDetractores.vue?vue&type=script&lang=js"
import style0 from "./PromotoresDetractores.vue?vue&type=style&index=0&id=69394ec3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69394ec3",
  null
  
)

export default component.exports